import React from 'react'

import { Box } from 'widgets/Box'

interface Props {
  value: number
}

export const ProgressIndicator = ({ value }: Props) => {
  return (
    <Box
      testID='PostProgressIndicator'
      position='relative'
      height={2}
      backgroundColor='grey'
      width='100%'
    >
      <Box position='absolute' height={2} backgroundColor='v2primary' width={`${value}%`} />
    </Box>
  )
}
